<!-- filepath: /Users/akatsios/Projects/siv2/src/components/monitoring/AIOOverviewDialog.vue -->
<template>
    <v-dialog v-model="dialog" max-width="800px" @click:outside="$emit('close')">
        <v-card>
            <v-card-title>
                <v-icon class="mr-1" color="blue">mdi-star-four-points</v-icon> AI Overview: {{ overviewData.keyword }}
                <v-btn right absolute @click="$emit('close')" class="dialog-close-btn" icon><v-icon color="primary">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text style="color: rgba(0, 0, 0, 0.8)">
                <div v-for="(item, index) in overviewData.items" :key="index" class="mb-4">
                    <h3 v-if="item.title" style="font-size: 1.25rem; font-weight: 500; letter-spacing: 0.0125em">{{ item.title }}</h3>
                    <p>{{ item.text }}</p>
                    <div v-if="item.references && item.references.length" style="background-color: #f2f2f2; padding: 15px 10px; border-radius: 10px">
                        <v-chip small class="mb-1" color="primary">References</v-chip>
                        <ul>
                            <li v-for="(ref, refIndex) in item.references" :key="refIndex">
                                <a :href="ref.url" target="_blank"
                                    >{{ extractDomainAndPath(ref.url) }}
                                    <!-- <a :href="ref.url" target="_blank">{{ ref.source }} - {{ ref.title }}</a> -->
                                    <v-chip style="cursor: pointer" class="px-1 ml-1" x-small color="priamry"> <v-icon size="12px">mdi-link-variant</v-icon></v-chip>
                                </a>

                                <p>{{ ref.text }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="$emit('close')">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            dialog: {
                type: Boolean,
                required: true
            },
            overviewData: {
                type: Object,
                required: true
            }
        },
        methods: {
            extractDomainAndPath(url) {
                try {
                    const { hostname, pathname } = new URL(url)
                    return `${hostname}${pathname}`
                } catch (error) {
                    console.error("Invalid URL:", url)
                    return url
                }
            }
        }
    }
</script>

<style scoped>
    .mb-4 {
        margin-bottom: 16px;
    }
</style>
